// src/components/scheduler/ChipMultiSelect.jsx
import React from "react";
import {
  Box,
  Chip,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";

const ITEM_HEIGHT = 38;
const ITEM_PADDING_TOP = 8;
const defaultMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6 + ITEM_PADDING_TOP,
      width: 320,
    },
  },
};

export default function ChipMultiSelectControl({
  label,
  labelId,
  value,           // array<string>
  onChange,        // fn(array<string>)
  options,         // array<string>
  disabled = false,
  MenuProps = defaultMenuProps,
  fullWidth = true,
  margin = "dense",
}) {
  const selectedSet = React.useMemo(() => new Set(value || []), [value]);

  return (
    <FormControl fullWidth={fullWidth} margin={margin} disabled={disabled}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        multiple
        value={value}
        onChange={(e) => onChange(e.target.value)}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {(selected || []).map((v) => (
              <Chip key={v} label={v} size="small" />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {options.map((opt) => {
          const checked = selectedSet.has(opt);
          return (
            <MenuItem
              key={opt}
              value={opt}
              selected={checked}
              sx={{ fontWeight: checked ? 600 : 400 }}
            >
              <Checkbox checked={checked} />
              <ListItemText primary={opt} />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
